import * as React from 'react';
import type { SVGProps } from 'react';

const IconCurvedArrow = (props: SVGProps<SVGSVGElement>) => {
  const clipPathID = 'curvedArrow';
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="14" fill="none" {...props}>
      <g clipPath={`url(#${clipPathID})`}>
        <path
          fill="currentColor"
          d="m17.095 7.122-6.574-6.5v3.805c-2.57.407-5.358 2.1-7.131 3.985C1 10.76.22 13.414.095 13.61c2.859-2.28 6.271-3.546 10.426-3.886v3.897l6.574-6.5Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="currentColor" d="M.095.622h17v13h-17z" />
        </clipPath>
      </defs>
    </svg>
  );
};
export default IconCurvedArrow;
